import {gql} from '@apollo/client'

export const VERIFY_PROCEDURE_CURRENT_STATUS = gql`
  query verifyProcedureCurrentStatus($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        procedureType
        status
      }
    }
  }
`

export interface VerifyProcedureCurrentStatusQueryVariables {
  procedureStatusId: string
}

export interface VerifyProcedureCurrentStatusQueryResult {
  client: {
    id: string
    procedureStatus?: {
      id: string
      procedureType: string
      status: string
    }
  }
}
